import { createTheme } from '@mui/material';
export const getMuiTheme = () => createTheme({
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: '1.1em',
                    whiteSpace: 'pre-wrap',
                },
            },
        },
        MUIDataTable: {
            styleOverrides: {
                paper: {
                    boxShadow: 'none',
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    justifyContent: 'center',
                    backgroundColor: 'white',
                    height: 32,
                    minHeight: 32,
                    '@media (min-width: 600px)': {
                        minHeight: 32,
                    },
                },
            },
        },
        MUIDataTableFilterList: {
            styleOverrides: {
                root: {
                    paddingBottom: '8px',
                },
            },
        },
        MUIDataTableBodyRow: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        backgroundColor: 'rgba(0, 143, 197, 0.6) !important',
                    },
                    '&:nth-of-type(even)': {
                        backgroundColor: 'rgba(0, 143, 197, 0.1)',
                    },
                    '&:hover': {
                        backgroundColor: 'rgba(0, 143, 197, 0.3) !important',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    justifyContent: 'center',
                },
            },
        },
        MUIDataTableHeadCell: {
            styleOverrides: {
                hintIconWithSortIcon: {
                    color: 'darkgray',
                    fontSize: '16px',
                    marginLeft: 0,
                },
                hintIconAlone: {
                    color: 'darkgray',
                    fontSize: '16px',
                    marginLeft: 0,
                },
                contentWrapper: {
                    display: 'inline',
                },
                toolButton: {
                    lineHeight: 1.35,
                    margin: 0, // remove the weird alignment it gives otherwise to the header
                },
                root: {
                    textAlign: 'center',
                    backgroundColor: '#ededed',
                    padding: 0,
                    lineHeight: 1.35,
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    letterSpacing: 0,
                },
                body: {
                    padding: 1,
                },
                paddingCheckbox: {
                    padding: '0px !important',
                },
            },
        },
        MUIDataTableSelectCell: {
            styleOverrides: {
                headerCell: {
                    lineHeight: 1.35,
                    backgroundColor: '#ededed !important',
                },
            },
        },
    },
});
export const customFilterWithPrefix = (prefix) => {
    return {
        customFilterListOptions: {
            render: (value) => {
                if (value == null)
                    return prefix + ': None';
                return prefix + ': ' + value;
            },
        },
    };
};
